
interface PluginType {
    id: string,
    name: string,
    config: _PluginConfig
}

export type _PluginConfig = {
    [key: string]: any
}

export type _PluginParams = {
    [key: string]: any
}

namespace Plugins {

    export type Plugin = PluginType;
    export type Config = _PluginConfig
    export type Params = _PluginParams

    export function getVersion() {
        return '1.0.0';
    }
}

export default Plugins;

export const PluginList: PluginType[] = [
    {
        id: 'tangoCard',
        name: 'Tango Card',
        config: {
            accountIdentifier: '',
            customerIdentifier: '',
            utid: '',
            etid: '',
            environment: 'production' // production or sandbox
        },
    },
    {
        id: 'apcPoints',
        name: 'APC Points',
        config: {
            environment: 'production' // production or sandbox
        }
    },
    {
        id: 'everi',
        name: 'Everi',
        config: {
            environment: 'production' // production or sandbox
        }
    }
]